<script setup lang="ts">
import { ref } from 'vue'

const localLyricsText = defineModel<string>('modelValue')
</script>
<template>
  <div>
    <el-input
      type="textarea"
      :rows="8"
      placeholder="请输入歌词"
      resize="none"
      class="lyrics-textarea"
      v-model="localLyricsText"
      :autosize="{ minRows: 10, maxRows: 30 }"
    />
  </div>
</template>
<style scoped>
.lyrics-textarea {
  :deep(.el-textarea__inner) {
    border: none;
    box-shadow: none !important;

    &:focus {
      box-shadow: none !important;
    }
  }
}
</style>
